// Components
import Box from "@mui/material/Box";
import ProgressionLineCharts from "src/components/containers/shared/ProgressionLineCharts/ProgressionLineCharts";

type LineChartContainerType = {
  lineChartData: Array<{
    age: string | number;
    time: string;
    MD: string | number | null;
    PSD: string | number | null;
    VRFI: number | null;
    pointShape: string;
    isRetinaLogikExam: boolean;
  }>;
};

const LineChartContainer = ({ lineChartData }: LineChartContainerType) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minWidth: { xs: "100%", md: "30%" },
        padding: "20px",
        borderRight: { xs: "none", md: "1px solid #435B6D7A" },
        borderBottom: { xs: "1px solid #435B6D7A", md: "none" },
        flex: 1,
        overflowY: { xs: "visible", md: "auto" },
      }}
    >
      <ProgressionLineCharts chartData={lineChartData} chartHeight={180} />
    </Box>
  );
};

export default LineChartContainer;
